import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';
import appMessages from 'features/App/App.messages';

import { getTopicById, makePanelId } from './HowSmartRateWorks.constants';
import SmartRateTopicPanel from './SmartRateTopicPanel';
import './SmartRateHowItWorksModal.scss';

const { block, element } = bem('smart-rate-how-it-works-modal');

export const SMART_RATE_HOW_IT_WORKS_MODAL_NAME = 'SmartRateHowItWorksModal';

const SmartRateHowItWorksModal = ({ closeModal, topicId }) => {
  const intl = useIntl();
  const topic = getTopicById(topicId);

  useEffect(() => {
    if (!topic) {
      closeModal();
    }
  }, [closeModal, topic]);

  if (!topic) {
    return null;
  }

  return (
    <div className={block()}>
      <div className={element('header')}>
        <button
          aria-label={intl.formatMessage(appMessages.close)}
          className={element('close-button')}
          onClick={closeModal}
          type="button">
          <Isvg aria-hidden src={ICONS.cross} />
        </button>
      </div>
      <div className={element('body')}>
        <SmartRateTopicPanel
          onClose={closeModal}
          panelId={makePanelId(topicId)}
          showCloseButton={false}
          topicId={topicId}
        />
      </div>
    </div>
  );
};

SmartRateHowItWorksModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  topicId: PropTypes.string.isRequired,
};

SmartRateHowItWorksModal.modalConfig = {
  overlayClassName: element('overlay'),
  className: element('content'),
};

export default SmartRateHowItWorksModal;
